var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#3779E1",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3086 16.1797C15.3086 18.0664 18.6133 19.3906 23.5 19.3906C28.3867 19.3906 31.6914 18.0664 31.6914 16.1797C31.6914 14.2109 28.4102 12.8398 23.5 12.8398C18.5898 12.8398 15.3086 14.2109 15.3086 16.1797ZM23.5 26.6445C19.1523 26.6445 15.8945 25.6602 13.4219 23.5625V16.1797C13.4219 13.2266 17.4531 11.1875 23.5 11.1875C29.5469 11.1875 33.5781 13.2266 33.5781 16.1797V23.5625C31.1055 25.6602 27.8477 26.6445 23.5 26.6445ZM13.4219 30.3594V25.6016C16.0352 27.5234 19.2812 28.4141 23.5 28.4141C27.7188 28.4141 30.9648 27.5234 33.5781 25.6016V30.3594C33.5781 33.5938 29.5117 35.8789 23.5 35.8789C17.4883 35.8789 13.4219 33.5938 13.4219 30.3594Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.6c3feae5a310a29272a8e375f18cffaa.svg";
export { ForwardRef as ReactComponent };